import { getAccessToken } from "../helpers/AccessToken";
import { API_BASE_URL } from "../config";

const API_URL = `${API_BASE_URL}/grupos`;

// Función para obtener las competiciones
export const getGruposByCompeticion = async (idCompeticion, navigate) => {
  try {
    const token = await getAccessToken(navigate);
    const response = await fetch(
      `${API_URL}/${idCompeticion}`,
      {
        method: "GET",
        cache: "no-cache",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
      }
    );

    if (response.ok) {
      const data = await response.json();
      return data; // Devuelve los datos de las temporadas
    } else {
      throw new Error("Error al obtener los grupos");
    }
  } catch (error) {
    throw error;
  }
};
